import React from 'react';

import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import Checkbox from 'react-bootstrap/lib/Checkbox';

import OutboundLink from '../../../../components/OutboundLink';

import styles from './ConfirmationModal.sass';

const ConfirmationModal = ({
  isShowing,
  onHide,
  onToggleOwnershipCheckbox,
  isOwnershipChecked,
  onSubmit,
  rssFeedMetadata,
  rssFeedUrl,
}) => (
  <Modal show={isShowing} onHide={onHide}>
    <Modal.Header closeButton>
      <h2 style={{ textAlign: 'center', fontSize: '22px' }}>
        Please confirm ownership
      </h2>
    </Modal.Header>
    <Modal.Body className="text-center">
      {rssFeedMetadata && (
        <p style={{ textAlign: 'left', marginTop: '0' }}>
          Before we can import {rssFeedMetadata.podcastName} to Anchor, please
          confirm that you own the rights to this podcast and that you agree
          to&nbsp;
          <OutboundLink to="/tos" className={styles.link}>
            Anchor’s Terms of Service.
          </OutboundLink>
        </p>
      )}
      <Checkbox name="isOwnPodcast" onChange={onToggleOwnershipCheckbox}>
        Yes, this is my podcast.
      </Checkbox>
      <Button
        block
        type="button"
        bsStyle="primary"
        disabled={!isOwnershipChecked}
        onClick={() => {
          onSubmit(rssFeedUrl);
        }}
      >
        NEXT
      </Button>
    </Modal.Body>
  </Modal>
);

export default ConfirmationModal;
